import { useEffect } from "react";
import { usePrefetch } from "@design-lab/app/usePrefetch";
import { PRODUCT_LIST_PATH } from "@design-lab/shared/constants/constants";
import { trackDesignLabSessionStart } from "@design-lab/shared/lib/analytics";
import { useDeliveryDateRefresh } from "@design-lab/shared/hooks/useDeliveryDateRefresh";
import { DtfChannelProvider } from "@design-lab/shared/hooks/useDtfChannel";
import { DtfInitProvider } from "@design-lab/widgets/design-lab-upload-artwork";
import { ProviderComposer } from "@design-lab/shared/lib/ProviderComposer";
import { ArtworkFormProvider, ArtworkProvider } from "@design-lab/entities/artwork";
import { CompositionFormProvider } from "@design-lab/entities/composition";
import { DesignProjectSyncProvider } from "@design-lab/features/design-project";
import { DesignLabPage } from "@design-lab/pages/design-lab/DesignLabPage";

export function DesignLabRoute() {
  // Prefetch the product list page
  usePrefetch(PRODUCT_LIST_PATH);

  // Listen for address updates to refresh delivery dates
  useDeliveryDateRefresh();

  useEffect(() => {
    trackDesignLabSessionStart();
  }, []);

  const providers = [
    DtfChannelProvider,
    DtfInitProvider,
    CompositionFormProvider,
    ArtworkFormProvider,
    ArtworkProvider,
    DesignProjectSyncProvider
  ];

  return (
    <ProviderComposer providers={providers}>
      <DesignLabPage />
    </ProviderComposer>
  );
}
